import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  hireTalentSignUpAPI,
  addCompanyDetailsAPI,
  hireTalentSection2API,
  hireTalentSection3API,
  hireTalentSection4API,
  hireTalentProfileAPI,
  hireTalentUpdateProfileStepAPI,
  addPostJobHireTalant,
  getMyPostJobListEndPointURL,
  updatePostJobHireTalant,
  deleteJobPostEndPointURL,
} from "../../../../routes/apiurls";

// hire-talent-sign-up
export const hireTalentSignUp = createAsyncThunk(
  "hire-talent-sign-up",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSignUpAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// add-company-details
export const addCompanyDetails = createAsyncThunk(
  "add-company-details",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: addCompanyDetailsAPI,
        method: "POST",
        data: payload,

        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-section-2
export const updateHireTalentSection2 = createAsyncThunk(
  "hire-talent-update-section-2",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSection2API,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-section-3
export const updateHireTalentSection3 = createAsyncThunk(
  "hire-talent-update-section-3",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSection3API,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-section-4
export const updateHireTalentSection4 = createAsyncThunk(
  "hire-talent-update-section-4",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentSection4API,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// get hire-talent profile
export const fetchHireTalentProfile = createAsyncThunk(
  "hire-talent-profile",
  async () => {
    try {
      const response = await API_REQUEST({
        url: hireTalentProfileAPI,
        method: "GET",
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) {
      return null;
    }
  }
);

// update hire-talent profile (multipart)
export const updateHireTalentProfileStep = createAsyncThunk(
  "hire-talent-update-profile-step",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: hireTalentUpdateProfileStepAPI,
        method: "POST",
        data: payload,
        headers: { "Content-Type": "multipart/form-data" },
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Add Job Post
export const addJobPostByHireTalent = createAsyncThunk(
  "add-job-post-hire-talent",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: addPostJobHireTalant,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Update Job Post
export const updateJobPostByHireTalent = createAsyncThunk(
  "update-job-post-hire-talent",
  async (props) => {
    const { payload, callback, params } = props;
    try {
      const response = await API_REQUEST({
        url: `${updatePostJobHireTalant}${params}`,
        method: "PUT",
        data: payload,
        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// Delete Job Post
export const deleteJobPostByHireTalent = createAsyncThunk(
  "delete-job-post-hire-talent",
  async (props) => {
    const { callback, params } = props;
    try {
      const response = await API_REQUEST({
        url: `${deleteJobPostEndPointURL}${params}`,
        method: "DELETE",
        currentPanel: "hire-talent"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);
// Get Job Post
export const getJobPostData = createAsyncThunk("get-post-job-hire-talent", async () => {
  try {
    const response = await API_REQUEST({
      url: getMyPostJobListEndPointURL,
      method: "GET",
      currentPanel: "hire-talent"
    });
    return response;
  } catch (error) { }
}
);

